// extracted by mini-css-extract-plugin
module.exports = {"heiwa-header":"header_heiwa-header__2rUm3"};